import { observable, reaction, computed } from "mobx";
import { QuizObjectTableColumn } from './quiz-object-table-column';
import { SaveStatuses } from "./save-statuses";
import { axios } from "../../../../utils/axios";

import { AUTOSAVE_DELAY } from '../../constants/editor';

class QuizObjectTable {
    /**
     *  @property {Object[]} values A Set of values is a column of values for a single column.
     */
    @observable _id: string = "";
    @observable quiz_object_id: string = "";
    @observable slug: string = '';
    @observable name: string = '';
    @observable columns: Array<QuizObjectTableColumn> = [];
    @observable status: SaveStatuses = SaveStatuses.UNCHANGED;
    @observable deleted: boolean = false;
    
    constructor(quiz_object_id: string, tableData?: any) {
        this.quiz_object_id = quiz_object_id
        if (tableData && tableData.columns) {
            this._id = tableData._id;
            this.slug = tableData.slug;
            this.name = tableData.name;
            this.columns = tableData.columns.map((column: any) => {
                return new QuizObjectTableColumn(this, column)
            });
        } else {
            let column1 = new QuizObjectTableColumn(this);
            let column2 = new QuizObjectTableColumn(this);
            this.columns.push(column1);
            this.columns.push(column2);
        }

        reaction(
            () => {
                return JSON.stringify(this);
            },
            () => {
                this.persistTable();
            },
            { delay: AUTOSAVE_DELAY }
        );
    }

    setName(name: string) {
        this.name = name;
    }

    get Rows() {
        let rows: any[] = [];
        let rowCount = 0;

        if (this.columns.length == 0) {
            return rows;
        }
        
        if (this.columns[0].list) {
            rowCount = this.columns[0].list.length - 1;
        }

        for (let i = 0; i <= rowCount; i++) {
            let nextRow: any[] = [];
            this.columns.forEach((valueList) => {
                nextRow.push({
                    fromValueColumn: valueList,
                    tableValue: valueList.list[i]
                })
            });
            rows.push(nextRow);
        }
        return rows
    }

    getNextID() {
        let next = 0;
        if (this.columns.length == 1) {
            return next;
        }
        this.columns.forEach((column) => {
            if (column.id !== undefined && next <= column.id) {
                next = column.id + 1;
            }
        })
        return next;
    }

    getNextOrderValue() {
        let next = 0;
        this.columns.forEach((column) => {
            if (column.order !== undefined && next <= column.order) {
                next = column.order + 1;
            }
        })
        return next;
    }

    remove() {
        this.deleteTable();
    }

    restore() {
        this.restoreTable();
    }

    async deleteTable() {
        this.status = SaveStatuses.DELETING;
        axios()
            .patch(`/quiz_objects/${this.quiz_object_id}`, {
                deleteTable: this
            })
            .then(() => {
                this.deleted = true;
                this.status = SaveStatuses.DELETED;
            })
            .catch((res: any) => {
                this.status = SaveStatuses.ERROR;
            });
    }

    async restoreTable() {
        this.status = SaveStatuses.RESTORING;
        axios()
            .patch(`/quiz_objects/${this.quiz_object_id}`, {
                table: this
            })
            .then((res: any) => {
                this.status = SaveStatuses.RESTORED;
                return res.data;
            })
            .catch((res: any) => {
                this._id = res.updated._id;
                this.status = SaveStatuses.ERROR;
            });
    }

    deleteRow(row : number) {
        for (let i = 0; i <= this.columns.length - 1; i++) {
            this.columns[i].removeRow(row);
        }
        console.log(`Deleting Row ${row}`);
    }
    
    switchOrder() {

    }

    addColumn() {
        let newArray = [];

        for (let i = 1; i <= this.columns[0].list.length; i++) {
            newArray.push('');
        }

        let newColumn = new QuizObjectTableColumn(this,
            {
                valueType: 'string',
                list: newArray,
                order: this.getNextOrderValue()
            }
        )
        this.columns.push(newColumn);        
    }

    addRow() {
        for (let i = 0; i <= this.columns.length - 1; i++) {
            this.columns[i].addRow();
        }
    }

    busy() {
        return (this.status == SaveStatuses.SAVING || this.status == SaveStatuses.RESTORING || this.status == SaveStatuses.DELETING );
    }

    async persistTable() {
        let _this = this;
        if (this.busy() || this.deleted) return;
        this.status = SaveStatuses.SAVING;
        axios()
            .patch(`/quiz_objects/${this.quiz_object_id}`, {
                table: this
            })
            .then((res: any) => {
                return res.data;
            })
            .then((res: any) => {
                _this._id = res.updated._id;
                _this.status = SaveStatuses.SAVED;
            })
            .catch((err: any) => {
                _this.status = SaveStatuses.ERROR;
            });
    }

}

export {
    QuizObjectTable
}